import React from 'react'

import ReactPaginate from 'react-paginate'

export default function PreviewPagination({ currentPage, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const handlePageClick = (event) => {
        onPageChange(event.selected + 1);
    };

    return (
        <ReactPaginate className="flex justify-center pt-7 pb-6 text-[#C2C2C2]" 
            previousLabel={
                <button className={` ${currentPage === 1 ? 'cursor-default' : ''} mr-2 `}>
                    <img decoding="async" loading="lazy" id="previous-page" src={currentPage === 1 ? 
                        "/images/ArrowButton.png" : '/images/arrow-left-dark.svg'} alt="icon" />
                </button>
            }
            nextLabel={
                <button className={` ${currentPage === totalPages ? 'cursor-default' : ''} ml-3 `}>
                    <img decoding="async" loading="lazy" id="next-page" src={currentPage === totalPages ? 
                        "/images/disable-arrow.png" : "/images/active-arrow.png" } alt="icon" />
                </button>
            }
            breakLabel="..."
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            forcePage={currentPage - 1}
            onPageChange={handlePageClick}
            containerClassName="flex justify-center items-center"
            pageClassName={
                "text-[12px] leading-normal font-semibold mr-1 bg-white w-[32px] h-[30px] " +
                "inline-flex justify-center items-center"
            }
            activeClassName="text-[#1E1E1E] underline decoration-2 underline-offset-4"
        />
    )
}
